import { Separator } from "@/elements"
import clsx from "clsx"
import React from "react"

export const CreativeCreditSkeleton: React.FC<{
  showSeparator?: boolean
  grid?: boolean
}> = ({ showSeparator = true, grid = false }) => {
  return (
    <div className={clsx("flex w-full flex-col")}>
      <div className={clsx("flex flex-row items-center", grid && "grid w-full grid-cols-12")}>
        <div className={clsx(grid && "col-span-6")}>
          <div className="h-[21px] w-[82px] animate-pulse rounded-sm bg-bg-2" />
        </div>
        <div className={clsx(grid ? "col-span-6" : "ml-2")}>
          <div
            className={clsx(
              "flex h-[36px] w-fit flex-shrink flex-grow-0 flex-row items-center gap-[6px] rounded-md bg-bg-2 px-[6px] py-1"
            )}>
            <div className="h-[40px] w-[125px] animate-pulse rounded-sm bg-bg-2" />
          </div>
        </div>
      </div>
      {showSeparator && <Separator className="mt-2" />}
    </div>
  )
}
